import { useState } from 'react';
import './ImageWithSkeleton.css';
export default function ImageWithSkeleton({ src, alt, caption , fancybox}) {
  const [loaded, setLoaded] = useState(false);

  return (
    <a href={src} data-fancybox={fancybox} data-caption={caption}>
      {!loaded && <div className="ImageWithSkeleton-skeleton" />}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        style={{ display: loaded ? 'block' : 'none' }}
      />
    </a>
  );
}
